<script lang="ts">
import { h, defineComponent, type PropType, type VNode } from 'vue';

import { Nullable } from '@/utils/types';
import { getBuildingDimensionLabel } from '@/bundles/MeasurementUnits/helpers/format/getBuildingDimensionLabel';

export default defineComponent({
  name: 'BuildingDimensionLabel',

  props: {
    value: {
      type: [String, Number] as PropType<Nullable<string | number>>,
      default: 0
    }
  },

  render (): VNode {
    const label = getBuildingDimensionLabel(this.$props.value);

    if (!label) {
      return h('span', { class: 'na' }, 'N/A');
    }

    return h('span', label);
  }
});
</script>
